import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IoTriangleSharp } from 'react-icons/io5';
import { useParams } from 'react-router-dom';
import { GameHeader } from '../../components/GameHeader';
import { Sidebar } from '../../components/Sidebar';

import { usePopup } from '../../hooks/popup';
import Clue from './Clue';
import Game from './Game';
import {
  getGameById,
  IHuntWordRes,
  ISolution,
  IWord,
} from './huntWordInterface';

import {
  Container,
  Content,
  GameContainer,
  GameContent,
  Layout,
} from './styles';

const MULTIPLICADOR = 10;

const HuntWords: React.FC = () => {
  let { id } = useParams();

  const { mountPopup } = usePopup();

  const textSplitted = useRef<string[]>([]);
  let arraySolution = useRef<ISolution[]>([]);
  const arrayCorrect = useRef<ISolution[]>([]);
  const [arrayTrigger, setTrigger] = useState<ISolution[]>([]);

  const [game, setGame] = useState<IHuntWordRes>();
  const [amountWords, setAmountWords] = useState(0);
  const [points, setPoints] = useState(0);
  const [gameEnded, setGameEnded] = useState(false);
  const [isHintUsed, setIsHintUsed] = useState(false);
  const [showWordHint, setShowWordHint] = useState(false);
  const [showLetterHint, setShowLetterHint] = useState(false);
  const [resetGame, setResetGame] = useState(false);
  const [width, setWidth] = useState(0);

  const createSolutions = (response: IWord[]) => {
    for (let solution of response) {
      let index = textSplitted.current.findIndex(
        (el) => el.toLowerCase() === solution.attributes.solution
      );
      arraySolution.current.push({
        x: solution.attributes.x.split('-'),
        y: solution.attributes.y.split('-'),
        solution: solution.attributes.solution,
        id: parseInt(solution.attributes.id),
        wordId: index,
      });
    }
  };

  const handleAcceptResponse = useCallback(
    (element: ISolution) => {
      let index = arraySolution.current.findIndex((el) => el === element);
      arrayCorrect.current.push(arraySolution.current[index]);
      setTrigger([...arrayTrigger, arraySolution.current[index]]);
      arraySolution.current.splice(index, 1);
      // setPoints((oldValue) => oldValue + MULTIPLICADOR);
    },
    [arrayTrigger]
  );

  useEffect(() => {
    const getWordSearch = async () => {
      try {
        if (id) {
          let response = await getGameById(parseInt(id));
          //Solucoes sao setadas para o jogo funcionar
          textSplitted.current = response.texto.split('*');
          createSolutions(
            response.game['crossword-compiler']['rectangular-puzzle'][
              'word-search'
            ].word
          );
          console.log('resp', response);
          console.log('array', arraySolution.current);
          setWidth(
            Number(
              response.game['crossword-compiler']['rectangular-puzzle'][
                'word-search'
              ].grid.attributes.width
            )
          );
          setGame(response);
          setAmountWords(arraySolution.current.length);
        } else {
          throw Error(`Falha ao carregar jogo de id ${id}`);
        }
      } catch (error) {
        console.log('ERROR', error);
      }
    };

    getWordSearch();
  }, [id]);

  useEffect(() => {
    if (points === 10 * MULTIPLICADOR) {
      setGameEnded(true);

      mountPopup({
        title: 'Parabéns!',
        message: 'Você finalizou este jogo! Por que não tenta algum outro?',
        buttons: [
          {
            buttonText: 'Ok',
            isPurple: true,
          },
        ],
        type: 'sucesso',
      });
    }
  }, [points, gameEnded, mountPopup]);

  return (
    <Container>
      <GameHeader
        maxScore={10 * MULTIPLICADOR}
        menuItems={[
          {
            buttonText: `Palavras Restantes - ${arraySolution.current.length}/${amountWords}`,
          },
          {
            buttonText: 'Revelar Resposta',
            buttonFunctions: () => {
              mountPopup({
                title: 'Deseja revelar a resposta?',
                message: 'Se utilizar a ajuda, sua pontuação será zerada!',
                buttons: [
                  {
                    buttonText: 'Sim',
                    buttonFunction: () => {
                      setIsHintUsed(true);
                      setPoints(0);
                      setGameEnded(true);
                    },
                  },
                  {
                    buttonText: 'Não',
                    isPurple: true,
                  },
                ],
                type: 'atencao',
              });
            },
          },
          {
            buttonText: 'Revelar Palavra',
            buttonFunctions: () => {
              mountPopup({
                title: 'Deseja revelar uma palavra?',
                message: 'Se utilizar a ajuda, sua pontuação será zerada!',
                buttons: [
                  {
                    buttonText: 'Sim',
                    buttonFunction: () => {
                      setShowWordHint(true);
                      setIsHintUsed(true);
                      setPoints(0);
                    },
                  },
                  {
                    buttonText: 'Não',
                    isPurple: true,
                  },
                ],
                type: 'atencao',
              });
            },
          },
          {
            buttonText: 'Revelar Letra',
            buttonFunctions: () => {
              mountPopup({
                title: 'Deseja revelar uma palavra?',
                message: 'Se utilizar a ajuda, sua pontuação será zerada!',
                buttons: [
                  {
                    buttonText: 'Sim',
                    buttonFunction: () => {
                      setIsHintUsed(true);
                      setShowLetterHint(true);
                      setPoints(0);
                    },
                  },
                  {
                    buttonText: 'Não',
                    isPurple: true,
                  },
                ],
                type: 'atencao',
              });
            },
          },
          {
            buttonText: 'Limpar Jogo',
            buttonFunctions: () => {
              mountPopup({
                title: 'Deseja limpar o jogo?',
                message:
                  'Se sim, a pontuação será zerada e o jogo recomeçará do início!',
                buttons: [
                  {
                    buttonText: 'Sim',
                    buttonFunction: () => {
                      setPoints(0);
                      setShowLetterHint(false);
                      setShowWordHint(false);
                      setGameEnded(false);
                      setResetGame(true);
                      arrayCorrect.current = [];

                      if (game) {
                        createSolutions(
                          game.game['crossword-compiler']['rectangular-puzzle'][
                            'word-search'
                          ].word
                        );

                        arraySolution.current.length = amountWords;
                        setTrigger([]);
                      }
                    },
                  },
                  {
                    buttonText: 'Não',
                    isPurple: true,
                  },
                ],
                type: 'atencao',
              });
            },
          },
        ]}
        type="CACAPALAVRAS"
        currentScore={isHintUsed ? 0 : points}
      />

      <Content>
        <GameContent>
          <div>
            {game && (
              <Layout>
                <GameContainer>
                  <Game
                    width={width}
                    resetGame={resetGame}
                    toggleResetGame={() => setResetGame(false)}
                    showLetter={showLetterHint}
                    toggleShowLetterHint={() => setShowLetterHint(false)}
                    showWord={showWordHint}
                    toggleShowWordHint={() => setShowWordHint(false)}
                    isFinished={gameEnded}
                    i={parseInt(
                      game.game['crossword-compiler']['rectangular-puzzle'][
                        'word-search'
                      ].grid.attributes.width
                    )}
                    j={parseInt(
                      game.game['crossword-compiler']['rectangular-puzzle'][
                        'word-search'
                      ].grid.attributes.height
                    )}
                    data={
                      game.game['crossword-compiler']['rectangular-puzzle'][
                        'word-search'
                      ]
                    }
                    solutions={arraySolution.current}
                    acceptResponse={handleAcceptResponse}
                  />
                </GameContainer>
              </Layout>
            )}

            <Sidebar
              maxScore={10 * MULTIPLICADOR}
              menuItems={[
                {
                  buttonText: `Palavras Restantes - ${arraySolution.current.length}/${amountWords}`,
                },
                {
                  buttonText: 'Revelar Resposta',
                  buttonFunctions: () => {
                    mountPopup({
                      title: 'Deseja revelar a resposta?',
                      message:
                        'Se utilizar a ajuda, sua pontuação será zerada!',
                      buttons: [
                        {
                          buttonText: 'Sim',
                          buttonFunction: () => {
                            setIsHintUsed(true);
                            setPoints(0);
                            setGameEnded(true);
                          },
                        },
                        {
                          buttonText: 'Não',
                          isPurple: true,
                        },
                      ],
                      type: 'atencao',
                    });
                  },
                },
                {
                  buttonText: 'Revelar Palavra',
                  buttonFunctions: () => {
                    mountPopup({
                      title: 'Deseja revelar uma palavra?',
                      message:
                        'Se utilizar a ajuda, sua pontuação será zerada!',
                      buttons: [
                        {
                          buttonText: 'Sim',
                          buttonFunction: () => {
                            setShowWordHint(true);
                            setIsHintUsed(true);
                            setPoints(0);
                          },
                        },
                        {
                          buttonText: 'Não',
                          isPurple: true,
                        },
                      ],
                      type: 'atencao',
                    });
                  },
                },
                {
                  buttonText: 'Revelar Letra',
                  buttonFunctions: () => {
                    mountPopup({
                      title: 'Deseja revelar uma palavra?',
                      message:
                        'Se utilizar a ajuda, sua pontuação será zerada!',
                      buttons: [
                        {
                          buttonText: 'Sim',
                          buttonFunction: () => {
                            setIsHintUsed(true);
                            setShowLetterHint(true);
                            setPoints(0);
                          },
                        },
                        {
                          buttonText: 'Não',
                          isPurple: true,
                        },
                      ],
                      type: 'atencao',
                    });
                  },
                },
                {
                  buttonText: 'Limpar Jogo',
                  buttonFunctions: () => {
                    mountPopup({
                      title: 'Deseja limpar o jogo?',
                      message:
                        'Se sim, a pontuação será zerada e o jogo recomeçará do início!',
                      buttons: [
                        {
                          buttonText: 'Sim',
                          buttonFunction: () => {
                            setPoints(0);
                            setShowLetterHint(false);
                            setShowWordHint(false);
                            setGameEnded(false);
                            setResetGame(true);
                            arrayCorrect.current = [];

                            if (game) {
                              createSolutions(
                                game.game['crossword-compiler'][
                                  'rectangular-puzzle'
                                ]['word-search'].word
                              );

                              arraySolution.current.length = amountWords;
                              setTrigger([]);
                            }
                          },
                        },
                        {
                          buttonText: 'Não',
                          isPurple: true,
                        },
                      ],
                      type: 'atencao',
                    });
                  },
                },
              ]}
              type="CACAPALAVRAS"
              currentScore={points}
            />
          </div>
          <button type="button">
            Palavras Restantes {arraySolution.current.length}/{amountWords}
          </button>
          {game && (
            <Clue
              isFinished={gameEnded}
              trigger={arrayTrigger}
              texto={textSplitted.current}
              solutions={arraySolution.current}
            />
          )}
        </GameContent>
        <p style={{ background: '#9FA7F7' }}>
          VER MAIS COMENTÁRIOS <IoTriangleSharp size={12} />
        </p>
      </Content>
    </Container>
  );
};

export default HuntWords;
